import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
} from 'antd';

import i18n from '../../config/i18n';
import Pagination from '../../components/shared/Pagination';
import FileList from '../../components/file/FileList';
import { FileAPIConnectors } from '../../api/index';
import InputFile from '../../components/shared/InputFile';
import addIcon from '../../styles/icons/add-document.svg'; // downloaded from the internet, change later for commercial use
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import Link from '../../components/shared/Link';

import {
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
} from '../../constants/RoleConstants';

const FPPRoleWhiteList = [DOCTOR_ID, ASSISTANT_ID, NURSE_ID];
const styles = {
  button: {
    height: 60,
    width: 60,
    borderRadius: '50%',
    border: '2px solid white',
    background: '#18bc9c',
  },
  addIcon: {
    height: '25px',
    width: '25px',
    paddingLeft: '3.5px',
  },
  image: {
    width: 300,
    height: 300,
  },
  modal: {
    hint: { textAlign: 'left' },
  },
};

export class FileManageContainer extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      fetchPatientList: PropTypes.func.isRequired,
      fetchFileList: PropTypes.func.isRequired,
      fetchFileURL: PropTypes.func.isRequired,
      deleteFile: PropTypes.func.isRequired,
      createDangerAlert: PropTypes.func.isRequired,
      createSuccessAlert: PropTypes.func.isRequired,
      logIn: PropTypes.func.isRequired,
    }).isRequired,
    assessmentId: PropTypes.string.isRequired, // userSurveyId
    patient: PropTypes.shape({
      pageInfo: PropTypes.object.isRequired,
      isPatientListLoading: PropTypes.bool.isRequired,
    }).isRequired,
    file: PropTypes.shape({
      fileList: PropTypes.arrayOf(PropTypes.object).isRequired,
    }).isRequired,
    router: PropTypes.object.isRequired,
    user: PropTypes.shape({
      profile: PropTypes.shape({
        roleId: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };

  state = {
    modal: false,
    fileId: null,
    filter: {
      query: '',
      page: 0,
    },
    isFirstPage: true,
  };

  componentDidMount = async () => {
    const {
      actions: {
        fetchPatientList,
        createDangerAlert,
      },
    } = this.props;

    // patient action
    const result = await fetchPatientList(this.state.filter);
    if (result !== true) {
      createDangerAlert(result.message);
    }

    // file actions
    this.getFileList();
  };

  onSubmit = async (e) => {
    await e.preventDefault();
    const {
      actions: {
        createAlert,
        createSuccessAlert,
        createDangerAlert,
        fetchFileURL,
        logIn,
      },
      assessmentId,
    } = this.props;
    const { fileId } = this.state;

    await logIn(
      this.account.value,
      this.password.value,
      {
        onSucceed: async () => {
          createSuccessAlert(i18n.t('validAuth'));

          // fetch file url
          const data = await fetchFileURL({ assessmentId, fileId });
          if (data.url) {
            window.location.href = data.url;
            this.getFileList();
          } else {
            createDangerAlert(data.message);
          }
        },
        onFail: err => createAlert({
          ...err,
          warningMsg: i18n.t('invalidAccountPwd'),
        }),
      },
    );

    this.setState({
      modal: false,
    });
  };

  onCancel = () => {
    this.setState({
      modal: false,
    });
  };

  getFileList = async () => {
    const {
      actions: {
        fetchFileList,
        createDangerAlert,
      },
      assessmentId,
    } = this.props;

    // Fetch file list
    const result = await fetchFileList(assessmentId);
    if (result !== true) {
      createDangerAlert(result.message);
    }
  };

  getLoginPopup = () => {
    const { router } = this.props;
    const { modal } = this.state;
    return (
      <Modal show={modal}>
        <ModalHeader>
          {i18n.t('plzEnterAccountPwd')}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={this.onSubmit}>
            <FieldGroup
              id="formControlsText"
              type="text"
              label="Account"
              placeholder={i18n.t('account')}
              inputRef={(input) => { this.account = input; }}
            />
            <FieldGroup
              id="formControlsPassword"
              type="password"
              label="Password"
              placeholder={i18n.t('pwd')}
              onChange={this.handleInputChange}
              inputRef={(input) => { this.password = input; }}
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 11 }}
              style={styles.modal.hint}
            >
              {i18n.t('downloadHintDescription')}
              <Link router={router} href="/frequently-asked-questions">
                {i18n.t('downloadHintFAQ')}
              </Link>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 13 }}
            >
              <Button
                bsStyle="success"
                onClick={this.onSubmit}
              >
                {i18n.t('submit')}
              </Button>
              <Button
                bsStyle="danger"
                onClick={this.onCancel}
              >
                {i18n.t('cancel')}
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    );
  };

  handleUploadButtonClick = (event) => {
    event.preventDefault();
    this.fileUpload.triggerClick();
  };

  handleFileUpload = (file) => {
    const {
      assessmentId,
    } = this.props;
    const uploadPromise = this.fileUpload.fileUploadWrapper(
      file,
      FileAPIConnectors.uploadUserFile,
      { assessmentId },
    );
    uploadPromise
      .then((data) => {
        this.getFileList(assessmentId);
        return data;
      });
  };

  handleDownloadButtonClick = (fileId) => {
    this.setState({
      modal: true,
      fileId,
    });
  };

  handleDeleteButtonClick = async (fileId) => {
    const {
      actions: {
        deleteFile,
        createDangerAlert,
      },
      assessmentId,
    } = this.props;
    const result = await deleteFile({ assessmentId, fileId });
    if (result === true) {
      this.getFileList();
    } else {
      createDangerAlert(result.message);
    }
  };

  render() {
    const { user: { profile: { roleId } } } = this.props;
    return (
      <div className="row">
        {this.getLoginPopup()}
        <div className="col-md-12">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h1>{i18n.t('fileList')}</h1>
            <button
              type="file"
              style={styles.button}
              onClick={this.handleUploadButtonClick}
            >
              <img
                style={styles.addIcon}
                className="svg-icon"
                alt={i18n.t('add')}
                src={addIcon}
              />
            </button>
          </div>
          <div className="row">
            <div className="col-lg-7 right">
              <Pagination
                pageInfo={this.props.patient.pageInfo}
                isLoading={this.props.patient.isPatientListLoading}
                onClickPage={this.onClickPage}
                isFirstPage={this.state.isFirstPage}
              />
            </div>
          </div>
          <div>
            <FileList
              fileList={this.props.file.fileList || []}
              isLoading={this.props.file.isFileListLoading}
              router={this.props.router}
              onDownloadButtonClick={this.handleDownloadButtonClick}
              onDeleteButtonClick={this.handleDeleteButtonClick}
              viewOnly={!FPPRoleWhiteList.includes(roleId)}
            />
            <br />
            <InputFile
              actions={this.props.actions}
              style={{ display: 'none' }}
              ref={(input) => { this.fileUpload = input; }}
              onSelectFile={this.handleFileUpload}
            />
          </div>
        </div>
      </div>
    );
  }
}

const FieldGroup = ({ id, label, help, ...props }) => (
  <FormGroup controlId={id}>
    <ControlLabel>{label}</ControlLabel>
    <FormControl {...props} />
    {help && <HelpBlock>{help}</HelpBlock>}
  </FormGroup>
);

export default connectActionsAndReducers(FileManageContainer);



// WEBPACK FOOTER //
// ./src/containers/file/FileManageContainer.js